import * as Yup from 'yup'
/* eslint-disable import/prefer-default-export */

export const schema = Yup.object().shape({
  resignationDescription: Yup.string().required('Este campo es requerido')
})
